import React, { useState } from 'react';
import CustomBootstrapTable from 'utils/reactTable';
import fileLogo from '../../image/Featured icon.png';
import { FaFileInvoice, FaRegTrashAlt, FaRedo } from 'react-icons/fa';
import { GoEye } from 'react-icons/go';
import Facture from './Facture';
import { FiPaperclip } from 'react-icons/fi';
//import { useGetProduitsQuery } from 'actions/produits/queries';
import { DEFAULT_API_IMAGE } from 'routes/api/endpoints';
import styled from 'styled-components';

const TableContainer = styled.div`
  .transaction-table-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }

  .transaction-table-scroll table {
    min-width: 980px;
  }
`;


import FilterableHeader from './transactionPageComp/FilterableHeader';
import { useMemo } from 'react';
import { useDossierRole } from 'contexts/DossierRoleContext';

// ... (existing styled component and imports)

const TransactionTable = ({
  data, // This is combinedData (page displayed) - WAIT. Filters should apply to ALL data.
  // Actually, filtering happens in parent. We just need to display filters UI here.
  allData, // We need full dataset to compute options (names, max amount)
  filters, // Current filter state from parent
  onFilterChange, // Handler to update filters in parent
  handleRowClick,
  selectedRows,
  onSelectRow,
  onEyeClick,
  onDeleteClick,
}) => {
  const { canEdit } = useDossierRole();
  // console.log({data}); 
  // No, keep original props too.

  const rowEvents = {
    onClick: (e, row) => {
      // console.log('Table row clicked:', row); 
      handleRowClick(row);
    },
  };

  // modal facture


  const [selectedRowData, setSelectedRowData] = useState(false);
  const [isFactureModalOpen, setIsFactureModalOpen] = useState(false);

  const handleOpenFactureModal = (rowData) => {
    setIsFactureModalOpen(true);
    setSelectedRowData(rowData);
  };

  const handleCloseFactureModal = () => {
    setIsFactureModalOpen(false);
  };


  // Calculate Options for Filters needed (Names, Max Amount)
  const filterOptions = useMemo(() => {
    const names = new Set();
    const DEFAULT_MAX = 1000000;
    let maxAmount = DEFAULT_MAX;
    const sourceData = allData?.length > 0 ? allData : (data || []);

    sourceData.forEach(t => {
      const client = t.client_details?.nom || t.client_nom;
      const supplier = t.fournisseurs_details?.nom || t.fournisseur_nom || t.fournisseurs;

      if (client) names.add(client);
      if (supplier) names.add(supplier);
      if (t.motif) names.add(t.motif);
      if (t.libelle) names.add(t.libelle);

      let rawAmount = t.montant_total || t.montant;
      if (typeof rawAmount === 'string') {
        rawAmount = rawAmount.replace(/[^0-9.-]+/g, "");
      }
      const amount = parseFloat(rawAmount) || 0;
      if (amount > maxAmount) maxAmount = amount;
    });

    return {
      names: Array.from(names).sort((a, b) => a.localeCompare(b)).map(n => ({ value: n, label: n })),
      maxAmount: Math.max(DEFAULT_MAX, Math.ceil(maxAmount))
    };
  }, [allData, data]);


  const columns = [
    {
      dataField: 'key', // 'Nom du fournisseur / Client'
      text: 'Partenaire',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="text"
          options={filterOptions.names}
          currentValue={filters?.names}
          onFilterChange={(val) => onFilterChange({ ...filters, names: val })}
          onSort={(direction) => {
            if (direction === null) {
              onFilterChange({ ...filters, sortBy: null, sortOrder: null });
            } else {
              onFilterChange({ ...filters, sortBy: 'names', sortOrder: direction });
            }
          }}
          currentSortBy={filters?.sortBy === 'names' ? 'names' : null}
          currentSortOrder={filters?.sortBy === 'names' ? filters?.sortOrder : null}
          onResetComplete={(emptyVal) => {
            onFilterChange({ 
              ...filters, 
              names: emptyVal, 
              sortBy: null, 
              sortOrder: null 
            });
          }}
        />
      ),
      formatter: (cell, row) => {
        const displayText =
          row?.fournisseurs ||
          (row?.fournisseurs_details && row?.fournisseurs_details.nom) ||
          (row?.client_details && row?.client_details.nom) ||
          row?.libelle || 'Inconnu';

        return (
          <div className="d-flex align-items-center gap-2">
            <img src={fileLogo} alt="File Icon" /> {displayText}
          </div>
        );
      },
    },
    {
  dataField: 'updated_at',
  text: 'Date',
  headerFormatter: (col) => (
    <FilterableHeader
      column={col}
      type="date"
      currentValue={{ start: filters?.dateStart, end: filters?.dateEnd }}
      onFilterChange={(val) => onFilterChange({ ...filters, dateStart: val.start, dateEnd: val.end })}
    />
  ),
  formatter: (cell, row) => {
    // ← Priorité à date_transaction, fallback sur updated_at
    const rawDate = row.date_transaction || cell;
    const date = new Date(rawDate);
    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear();

    // date_transaction est un DateField (sans heure), on n'affiche pas l'heure dans ce cas
    if (row.date_transaction) {
      return <div>{`${day}/${month}/${year}`}</div>;
    }

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    return <div>{`${day}/${month}/${year} ${hours}:${minutes}`}</div>;
  },
},
    {
      dataField: 'type',
      text: 'Type',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="multi-select"
          options={[
            { value: 'entree', label: 'Entrée' },
            { value: 'sortie', label: 'Sortie' },
            { value: 'rapprochement', label: 'Rapprochement' }
          ]}
          currentValue={filters?.types}
          onFilterChange={(val) => onFilterChange({ ...filters, types: val })}
        />
      ),
      formatter: (cell) => {
        const displayType = cell && cell === 'sortie' ? 'Sortie' : 'Entrée';
        const textColor = cell && cell === 'sortie' ? '#991B1B' : '#064E3B';
        const bkgrCOlor = cell && cell === 'sortie' ? '#FEF2F2' : '#ECFDF5';
        return (
          <div
            style={{
              color: textColor,
              padding: '1px',
              backgroundColor: bkgrCOlor,
              fontWeight: 'bold',
              textAlign: 'center',
              borderRadius: '5px',
            }}
          >
            {displayType}
          </div>
        );
      },
    },
    /*{
      dataField: 'source_paiement',
      text: 'Paiement par',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="multi-select"
          options={[
            { value: 'caisse', label: 'Caisse' },
            { value: 'banque', label: 'Banque' },
            { value: 'wave', label: 'Wave' },
            { value: 'orange_money', label: 'Orange Money' }
          ]}
          currentValue={filters?.paymentModes}
          onFilterChange={(val) => onFilterChange({ ...filters, paymentModes: val })}
        />
      ),
      formatter: (cell) => {
        let paymentMethod = '';
        switch (cell) {
          case 'wave': paymentMethod = 'Wave'; break;
          case 'orange_money': paymentMethod = 'Orange Money'; break;
          case 'banque': paymentMethod = 'Banque'; break;
          case 'caisse': paymentMethod = 'Caisse'; break;
          default: paymentMethod = 'Non défini'; break;
        }
        return <div>{paymentMethod}</div>;
      },
    },*/
    {
      dataField: 'montant_total',
      text: 'Versement',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="amount"
          min={0}
          max={filterOptions.maxAmount}
          currentValue={filters?.amountRange ? filters.amountRange : [0, Math.min(1000000, filterOptions.maxAmount)]}
          onFilterChange={(val) => onFilterChange({ ...filters, minAmount: val[0], maxAmount: val[1], amountRange: val })}
        />
      ),
      formatter: (cell, row) => {
        const raw = row.montant_paye ?? cell ?? 0;
        const num = Number(raw);
        const safeAmount = Number.isFinite(num) ? num : 0;
        const isDepense = row.type === 'entree';
        const textColor = isDepense ? '#009688' : '#991B1B';
        const formattedAmount = new Intl.NumberFormat('fr-FR').format(safeAmount) + ' FCFA';
        return <div style={{ color: textColor }}>{formattedAmount}</div>;
      }
    },
    {
      dataField: 'reste_a_payer',
      text: 'Reste',
      headerFormatter: (col) => (
        <FilterableHeader
          column={col}
          type="amount"
          min={0}
          max={filterOptions.maxAmount}
          currentValue={filters?.amountRange ? filters.amountRange : [0, Math.min(1000000, filterOptions.maxAmount)]}
          onFilterChange={(val) => onFilterChange({ ...filters, minAmount: val[0], maxAmount: val[1], amountRange: val })}
        />
      ),
      formatter: (cell, row) => {
        const raw = row.reste_a_payer ?? cell ?? 0;
        const num = Number(raw);
        const safeAmount = Number.isFinite(num) ? num : 0;
        const isDepense = row.type === 'entree';
        const textColor = isDepense ? '#009688' : '#991B1B';
        const formattedAmount = new Intl.NumberFormat('fr-FR').format(safeAmount) + ' FCFA';
        return <div style={{ color: textColor }}>{formattedAmount}</div>;
      }
    },
    {
      dataField: 'piece_joint',
      text: <FiPaperclip />,
      formatter: (cell, row) => (
        <div className="styleColonne" onClick={() => handleRowClick(row)}>
          {cell ? (
            <a href={`${DEFAULT_API_IMAGE}${cell}`} target="_blank" rel="noopener noreferrer">
              Pièce jointe
            </a>
          ) : (
            <span>Pas de pièce jointe</span>
          )}
        </div>
      ),
    },
    {
      dataField: 'justificatif_file',
      text: <FiPaperclip />,
      formatter: (cell, row) => {
        const file = row.piece_comptable_details?.fileUrl || row.piece_comptable_details?.fichier || cell || row.piece_joint;
        return (
          <div className="styleColonne" onClick={() => handleRowClick(row)}>
            {file ? (
              <a href={file.startsWith('http') ? file : `${DEFAULT_API_IMAGE}${file}`} target="_blank" rel="noopener noreferrer" style={{ color: '#009688', fontWeight: 600 }}>
                📎 Justificatif
              </a>
            ) : (
              <span style={{ color: '#94a3b8' }}>:</span>
            )}
          </div>
        );
      },
    },
    {
      dataField: 'id',
      text: 'Action',
      headerFormatter: () => (
        <div className="d-flex align-items-center justify-content-between">
          <span>Action</span>
          <FaRedo
            title="Réinitialiser tous les filtres"
            className="text-muted cursor-pointer ms-2"
            style={{ cursor: 'pointer', fontSize: '1rem' }}
            onClick={(e) => {
              e.stopPropagation(); // Prevent propagation
              onFilterChange({
                names: [],
                dateStart: '',
                dateEnd: '',
                types: [],
                paymentModes: [],
                amountRange: [0, filterOptions.maxAmount],
                minAmount: 0,
                maxAmount: filterOptions.maxAmount
              });
            }}
          />
        </div>
      ),
      formatter: (row) => (
        <div>
          <div className="d-flex fs-5 gap-3 transaction-action-icons">
            {canEdit && (
            <FaRegTrashAlt
              className="text-danger transaction-action-icon"
              onClick={(e) => {
                e.stopPropagation(); // Prevent the row click event
                onDeleteClick(row); // Call the passed delete handler
              }}
            />
            )}
            <GoEye
              className="transaction-action-icon"
              onClick={(e) => {
                e.stopPropagation(); // Prevent click from bubbling to the row's onClick event
                onEyeClick(row);
              }}
            />
            <FaFileInvoice className="transaction-action-icon" onClick={() => handleOpenFactureModal(row)} />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div>
      <Facture
        isOpen={isFactureModalOpen}
        onClose={handleCloseFactureModal}
        rowData={selectedRowData}
        data={data}
      ></Facture>
      <TableContainer>
        <div className="transaction-table-scroll">
          <CustomBootstrapTable
            keyField="key"
            data={data}
            columns={columns}
            rowEvents={rowEvents}
            selectedRows={selectedRows} // Forward the prop
            onSelectRow={onSelectRow} // Forward the prop
          />
        </div>
      </TableContainer>
    </div>
  );
};

export default TransactionTable;
